import { Plan, UpgradeReason } from '@zapier/upsells/src/types';

type Props = {
  plan: Plan | undefined;
  upgradeReason: UpgradeReason;
};

export const canUpgradeForReason = ({ plan, upgradeReason }: Props) => {
  let result: boolean | null | undefined = true;

  switch (upgradeReason) {
    case 'email-support': {
      result = plan?.type === 'Free';
      break;
    }

    case 'live-zaps': {
      result = plan?.zapLimit !== -1; // Can increase Zaps as long as they don't have unlimited.
      break;
    }

    case 'multistep': {
      result = !plan?.hasMultiStepZaps;
      break;
    }

    case 'paths': {
      result = !plan?.hasPaths;
      break;
    }

    case 'premium': {
      result = !plan?.hasPremiumApps;
      break;
    }

    case 'premium-limit': {
      result = !plan?.hasPremiumApps || plan?.premiumAppsLimit !== -1;
      break;
    }

    case 'tasks':
    case 'tasks-low': {
      result = true; // User can always get more tasks.
    }
  }

  return Boolean(result);
};
